import "@babel/polyfill";
import { humburger_menu, drawer_menu } from "./modules/humburger-menu";
// import { anchor_link } from "./modules/anchor-link";
// import { anchor_current } from "./modules/anchor-current";
import { window_size, viewport_less } from "./modules/theme";
// import { global_menu } from "./modules/global-menu";
import { ScrollTop } from "./modules/scroll-top";
import { tab_menus, tabs } from "./modules/tab-menu";
import { modal } from "./modules/modal";
// import { cardSwiper, cardSwiperSize, mvSwiper, slideSwiper, slideSwiperQuick } from "./modules/swiper";
import { mvSplide } from "./modules/splide";
import { details_state } from "./modules/details";
import { fsSearchItemCheckbox } from "./modules/saerch-item";
import { fetch_cases, fetch_info, fetch_medias, fetch_special } from "./modules/data-fetch";
import { output_alt } from "./modules/alt";
import { fs_item_sizedata } from "./modules/futureshop";
import { manager_comment } from "./modules/other";


// window size write to html tag
window_size();
viewport_less();

// global menu
// global_menu();

// humburger menu
humburger_menu();
drawer_menu();

// Scroll Top
ScrollTop();

// modal
modal();

// anchor link fix
// anchor_link();
// anchor_current();

// image map
// rwd_image_maps();

// loading use sessionStorage
// loading();

// tab menu
// tab_menus();
tabs();

// swiper
// cardSwiper();
// cardSwiperSize();
// mvSwiper();
// slideSwiper();
// slideSwiperQuick();

// splide
mvSplide();

// details summury
details_state();

// alt
output_alt();

// other
manager_comment();

// fetch from wp
fetch_cases();
fetch_info();
fetch_medias();
fetch_special();

// futureshop
fs_item_sizedata();
fsSearchItemCheckbox();
